import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiSummary from '../../Api/ApiSummary';
import ToastMsg from '../../Components/ToastMsg';
import { creators as SummaryActions } from '../../Reducers/Reporting/Summary';

export function* getSummary({ payload }) {
  try {
    const response = yield call(ApiSummary.getSummary, payload.dimdate);

    if (response.status === 200) {
      yield put(SummaryActions.summarySuccess({ summary: response.data.summary, reportingSummaries: response.data.reporting_summaries }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Summary',
            text: response.message,
          },
        },
      );
      yield put(SummaryActions.summaryFailure(response.message));
    }
  } catch (e) {
    yield put(SummaryActions.summaryFailure(e));
  }
}

export function* setSummary({ payload }) {
  try {
    const response = yield call(ApiSummary.setSummary, payload.dimdate, payload.content);

    if (response.status === 200) {
      yield put(SummaryActions.summarySuccess());
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Set Summary',
            text: response.message,
          },
        },
      );
      yield put(SummaryActions.summaryFailure(response.message));
    }
  } catch (e) {
    yield put(SummaryActions.summaryFailure(e));
  }
}
